import { render, staticRenderFns } from "./SetNuma.vue?vue&type=template&id=a56602f2"
import script from "./SetNuma.vue?vue&type=script&lang=js"
export * from "./SetNuma.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports